import axios from 'axios'

import { getEpsBaseUrl } from './eps-base-url'
import { remapClientBenefitsGetResponse } from './remap-client-benefits-get'

/**
 * GET /core/enrollments/:enrollmentPublicKey/client/benefits/:benefitType
 *
 * Drop-in replacement for enrollmentService({ route: '.../client/benefits/{BenefitType}', ... }).
 * Accepts legacy PascalCase params; forwards optional election/query fields unchanged.
 */
export function getClientBenefits({
  EnrollmentPublicKey,
  enrollmentKey,
  BenefitType,
  PersonPublicKeys,
  ...query
}) {
  const enrollmentPublicKey = EnrollmentPublicKey || enrollmentKey
  const params = { ...query }

  if (PersonPublicKeys != null) {
    params.PersonPublicKeys = Array.isArray(PersonPublicKeys)
      ? PersonPublicKeys.join(',')
      : PersonPublicKeys
  }

  return axios
    .get(
      `${getEpsBaseUrl()}/core/enrollments/${enrollmentPublicKey}/client/benefits/${BenefitType}`,
      { params }
    )
    .then(({ data }) => remapClientBenefitsGetResponse(data))
}
